import React, { memo } from "react";
import { useSelector } from "react-redux";
import i18n from "utils/i18n";
import { dataConstants } from "services/redux/data/constants";
import Text from "theme/Text";
import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'
import Button from 'theme/Button'
import { SCAN_STATUS, useEmployeeScanStatus } from 'utils/objects/employee-scan'
import isEqual from 'react-fast-compare'
import VStack from "components/atoms/stack/VStack";
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'

const ScanButton = ({ onPressScanInButton = null, onPressScanOutButton = null, loading = false, enabled = true }) => {
	
	const _settings = useSelector( state => {
		return state.data[dataConstants.SETTINGS];
	} ) // keep for refresh
	const { isScanningInEnabled, isScanningOutEnabled, isScanningEnabled, scanStatus } = useEmployeeScanStatus()
	
	if( !isScanningEnabled || !enabled ) {
		return null;
	}
	
	if( scanStatus !== SCAN_STATUS.SCANNED_IN && isScanningInEnabled ) {
		return (
			<VStack style={ styles.container }>

				<Text style={ styles.title }>{i18n.t( 'page.home.in_the_office')}</Text>
				
				<Button
					onPress={ onPressScanInButton }
					style={ styles.button }
					textStyle={ styles.buttonText }
					icon={ <Icon icon={ IconSystemConstants.PERSON_CHECK } style={ styles.buttonIcon } /> }
					disabled={ loading }
					isLoading={ loading }>
					
					{ i18n.t( 'page.start.button_scan_in' ) }
				</Button>
			</VStack>
		)
	}
	
	if( scanStatus === SCAN_STATUS.SCANNED_IN && isScanningOutEnabled ) {
		return (
			<VStack style={ styles.container }>

				<Text style={ styles.title }>{i18n.t( 'page.home.left_the_office')}</Text>
				
				<Button
					onPress={ onPressScanOutButton }
					style={ styles.button }
					textStyle={ styles.buttonText }
					icon={ <Icon icon={ IconSystemConstants.SIGN_OUT } style={ styles.buttonIcon } /> }
					disabled={ loading }
					isLoading={ loading }>
					
					{ i18n.t( 'page.start.button_scan_out' ) }
				</Button>
			</VStack>
		)
	}
	
	return (
		<Text style={ styles.title }>{ i18n.t( 'page.home.welcome_in_the_office') }</Text>
	)
}

const styles = StyleSheet.create({
	container: {
		width: '100%',
		backgroundColor: colorList.WHITE.primary,
		borderColor: colorList.GREY.dark,
		borderWidth: 1,
		borderRadius: 16,
		padding: 16,
	},
	title: {
		color: colorList.TITLE.primary,
		fontSize: 14,
		fontWeight: '700',
		textAlign: 'center',
		marginBottom: 12,
	},
	button:{
		backgroundColor: colorList.TITLE.primary,
		borderColor: colorList.TITLE.primary,
		borderRadius: 12,
		minHeight: 52,
	},
	buttonText: {
		color: colorList.WHITE.primary,
		fontSize: 16,
		fontWeight: '700',
	},
	buttonIcon: {
		color: colorList.WHITE.primary,
		fontSize: 20,
	},
});

export default memo( ScanButton, isEqual )
